export const CLEAR_RESULTS = 'CLEAR_RESULTS';
export const INCREMENT_PAGE = 'INCREMENT_PAGE';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const RESET_SEARCH = 'RESET_SEARCH';
export const RESET_SELECTED_FILTERS = 'RESET_SELECTED_FILTERS';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_PAGE = 'SET_PAGE';
export const SET_SEARCH_INPUT_VALUE = 'SET_SEARCH_INPUT_VALUE';
export const SET_SELECTED_FILTERS = 'SET_SELECTED_FILTERS';
export const SET_SHOULD_SEARCH = 'SET_SHOULD_SEARCH';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const FETCH_RESULTS_LOADING = 'FETCH_RESULTS_LOADING';
export const FETCH_RESULTS_SUCCESS = 'FETCH_RESULTS_SUCCESS';
export const FETCH_RESULTS_ERROR = 'FETCH_RESULTS_ERROR';

export const clearResults = () => ( { type: CLEAR_RESULTS } );

export const incrementPage = () => ( { type: INCREMENT_PAGE } );

export const removeFilter = ( groupIndex, filterName ) => ( {
	type: REMOVE_FILTER,
	groupIndex,
	filterName,
} );

export const resetSearch = () => ( { type: RESET_SEARCH } );

export const setActiveTab = activeTab => ( {
	type: SET_ACTIVE_TAB,
	activeTab,
} );

export const setFilters = filters => ( {
	type: SET_FILTERS,
	filters,
} );

export const setPage = page => ( { type: SET_PAGE, page } );

export const setSelectedFilters = selectedFilters => ( {
	type: SET_SELECTED_FILTERS,
	selectedFilters,
} );

export const setSearchInputValue = searchInputValue => ( {
	type: SET_SEARCH_INPUT_VALUE,
	searchInputValue,
} );

export const setShouldSearch = shouldSearch => ( {
	type: SET_SHOULD_SEARCH,
	shouldSearch,
} );

export const toggleFilter = ( groupIndex, filterName ) => ( {
	type: TOGGLE_FILTER,
	groupIndex,
	filterName,
} );

// Fetching data from Search API
export const fetchResultsLoading = () => ( {
	type: FETCH_RESULTS_LOADING
} );

export const fetchResultsSuccess = ( state )  => ( {
	...state,
	type: FETCH_RESULTS_SUCCESS,
} );

export const fetchResultsError = ( error ) => ( {
	type: FETCH_RESULTS_ERROR,
	error: error
} );
